<template>
  <div>
    <vocabulary fromType="hsk"></vocabulary>
  </div>
</template>
<script>
import vocabulary from '@/views/vocabulary/index'
export default{
  components:{
    vocabulary
  }
}
</script>
<style scoped lang="scss">
</style>
